export const VALID_NODE_NAMES = [
  `link`,
  `meta`,
  `style`,
  `title`,
  `base`,
  `noscript`,
  `script`,
  `html`,
  `body`,
]

export const ITEM_PROP_WORKAROUND_KEY = `itemProp`
export const ITEM_PROP_WORKAROUND_VALUE = `gatsby-do-not-hoist-me-react`
export const HTML_BODY_ORIGINAL_TAG_ATTRIBUTE_KEY = `data-original-tag`
